import { colors, styled, css } from 'canoe';
import React from 'react';

const FILL = colors.GlitterGrayL10;
const FILL_HOVER = colors.GlitterGray;
const FILL_ACTIVE = colors.GlitterGrayD10;

const Path = styled.path<{ isActive?: boolean }>`
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    fill: ${FILL_HOVER};
  }

  ${({ isActive }: any) =>
    isActive &&
    `
  fill: ${FILL_ACTIVE};
  &:hover {
    fill: ${FILL_ACTIVE};
  }
`}
`;

interface GroupProps {
  isActive?: boolean;
  isSelectable?: boolean;
}

const Group = styled.g<GroupProps>`
  ${({ theme }) => css`
    fill: ${FILL};
    stroke: ${theme.colors.GlitterGray};
    stroke-linecap: round;
    stroke-linejoin: round;

    ${(props: GroupProps) =>
      props.isSelectable &&
      !props.isActive &&
      `
    &:hover {
      fill: ${FILL_HOVER};
    }
  `}

    ${(props: GroupProps) =>
      props.isActive &&
      `
      fill: ${FILL_ACTIVE};
  `}
  `}
`;

interface Props {
  editProperty: (propName: string) => void;
  editedProperty: string | null;
  linkState: {
    margin: boolean;
    padding: boolean;
  };
}

export const SpacingBox = ({ editProperty, editedProperty, linkState }: Props) => (
  <svg
    viewBox="0 0 272 120"
    width={268}
    height={120}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="49" y="48" width="174" height="24" fill="white" />
    <Group
      id="padding-box"
      isSelectable={linkState.padding}
      isActive={linkState.padding && !!editedProperty && editedProperty.indexOf('padding') >= 0}
    >
      <Path
        id="path-padding-left"
        onClick={() => editProperty('paddingLeft')}
        isActive={editedProperty === 'paddingLeft' || editedProperty === 'padding'}
        d="M26 95V25L49 48V72L26 95Z"
      />
      <Path
        id="path-padding-bottom"
        onClick={() => editProperty('paddingBottom')}
        isActive={editedProperty === 'paddingBottom' || editedProperty === 'padding'}
        d="M246.5 95L26 95L49 72L223 72L246.5 95Z"
      />
      <Path
        id="path-padding-right"
        onClick={() => editProperty('paddingRight')}
        isActive={editedProperty === 'paddingRight' || editedProperty === 'padding'}
        d="M246.5 25L246.5 95L223.5 72L223.5 48L246.5 25Z"
      />
      <Path
        id="path-padding-top"
        onClick={() => editProperty('paddingTop')}
        isActive={editedProperty === 'paddingTop' || editedProperty === 'padding'}
        d="M26 25L246.5 25L223.5 48L49.5 48L26 25Z"
      />
    </Group>

    <Group
      id="border-box"
      isSelectable={linkState.margin}
      isActive={linkState.margin && !!editedProperty && editedProperty.indexOf('margin') >= 0}
    >
      <Path
        id="path-margin-left"
        onClick={() => editProperty('marginLeft')}
        isActive={editedProperty === 'marginLeft' || editedProperty === 'margin'}
        d="M1 119.5L1.5 0.5L25.25 24.5V96L1 119.5Z"
      />
      <Path
        id="path-margin-bottom"
        onClick={() => editProperty('marginBottom')}
        isActive={editedProperty === 'marginBottom' || editedProperty === 'margin'}
        d="M271.5 119.5L1 119.5L25 95.9998L247.5 95.9998L271.5 119.5Z"
      />
      <Path
        id="path-margin-right"
        onClick={() => editProperty('marginRight')}
        isActive={editedProperty === 'marginRight' || editedProperty === 'margin'}
        d="M271.5 0.500031L271.5 119.5L247.25 95.5L247.25 24L271.5 0.500031Z"
      />
      <Path
        id="path-margin-top"
        onClick={() => editProperty('marginTop')}
        isActive={editedProperty === 'marginTop' || editedProperty === 'margin'}
        d="M1.5 0.499992L271.5 0.5L247.5 24.0002L25 24L1.5 0.499992Z"
      />
    </Group>
  </svg>
);
